var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": ((_vm.isEdit ? '编辑':'添加') + "学校"),
      "visible": _vm.showDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.showDialog = $event
      }
    }
  }, [_c("el-form", {
    key: _vm.preventKey,
    ref: "ruleForm",
    tag: "component",
    staticClass: "form-beauty form-col",
    attrs: {
      "rules": _vm.rules,
      "model": _vm.ruleForm,
      "label-width": "130px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "学校名称",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 50,
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.ruleForm.name),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "name", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "ruleForm.name"
    }
  })], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "省份名称",
      "prop": "provinceId"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "请选择",
      "clearable": true
    },
    on: {
      "change": _vm.provinceChange
    },
    model: {
      value: (_vm.ruleForm.provinceId),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "provinceId", $$v)
      },
      expression: "ruleForm.provinceId"
    }
  }, _vm._l((_vm.selectMap.WB_PROVINCE_ALL_WITH_CITY), function(item, index) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.text,
        "value": item.value
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "text-right",
    attrs: {
      "span": 2
    }
  }, [_c('i', {
    staticClass: "el-icon-my-gengduo1",
    staticStyle: {
      "font-size": "24px",
      "vertical-align": "middle",
      "color": "#ddd",
      "position": "relative",
      "top": "5px"
    }
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "城市名称",
      "prop": "cityId",
      "label-width": "90px"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": true,
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.ruleForm.cityId),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "cityId", $$v)
      },
      expression: "ruleForm.cityId"
    }
  }, _vm._l((_vm.cityArr), function(item, index) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.text,
        "value": item.value
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "学校类型",
      "prop": "type"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择",
      "clearable": true
    },
    model: {
      value: (_vm.ruleForm.type),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "type", $$v)
      },
      expression: "ruleForm.type"
    }
  }, _vm._l((_vm.selectMap.WB_SCHOOL_TYPES), function(item, key) {
    return _c('el-option', {
      key: key,
      attrs: {
        "label": item.text,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "学校档位",
      "prop": "sLevel"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择",
      "clearable": true
    },
    model: {
      value: (_vm.ruleForm.sLevel),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "sLevel", $$v)
      },
      expression: "ruleForm.sLevel"
    }
  }, _vm._l((_vm.selectMap.WB_SCHOOL_LEVEL), function(item, key) {
    return _c('el-option', {
      key: key,
      attrs: {
        "label": item.text,
        "value": item.value
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "mb-10",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        return _vm.submitForm('ruleForm', true)
      }
    }
  }, [_vm._v("保存")]), _vm._v(" "), (!_vm.isEdit) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitForm('ruleForm', false)
      }
    }
  }, [_vm._v("保存并继续添加")]) : _vm._e()], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69bac047"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/more/schoolLevel/addRecordDialog.vue
// module id = null
// module chunks = 